import { render } from "./EmployeeViewPayment.vue?vue&type=template&id=11628ed2"
import script from "./EmployeeViewPayment.vue?vue&type=script&lang=js"
export * from "./EmployeeViewPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__